import { KLIKOO_PRODUCT } from "../../../constants/admin/masterdata/constants";

const initialState = {
  loadingGetKlikooProduct: true,
  loadingPostKlikooProduct: false,
  dataKlikooProduct: { data: [], meta: {} },
  categories: [],
};

export const klikooProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case KLIKOO_PRODUCT.GET_DATA_KLIKOO_PRODUCT_SUCCESS:
      return {
        ...state,
        dataKlikooProduct: action.data,
      };
    case KLIKOO_PRODUCT.LOADING_DATA_KLIKOO_PRODUCT_SUCCESS:
      return {
        ...state,
        loadingGetKlikooProduct: action.load,
      };
    case KLIKOO_PRODUCT.LOADING_POST_KLIKOO_PRODUCT_SUCCESS:
      return {
        ...state,
        loadingPostKlikooProduct: action.load,
      };
    case KLIKOO_PRODUCT.GET_CATEGORIES_KLIKOO_PRODUCT_SUCCESS:
      return {
        ...state,
        categories: Array.isArray(action.data) ? action.data : [],
      };
    default:
      return state;
  }
};
